import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=58c21689&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c21689",
  null
  
)

export default component.exports